import PagePlaceholder from "./PagePlaceholder";

const Billing = () => <PagePlaceholder title="Billing" />;

export default Billing;
